<div>
  <h1>Workflow Ownership Approval</h1>
  <br />
  <p>You have been assigned as the new owner of the following workflow:</p>
  <p>
    <b>WorkflowId: {{ paddedWorkflowId }}</b>
  </p>
  <p>
    <b>Owner: {{ previousOwner }}</b>
  </p>
  <p>
    Please review the details and choose to either accept or reject the
    ownership.
  </p>
  <div class="buttons">
    <button class="btn btn-secondary me-3" (click)="handleApproval(2)">
      Reject
    </button>
    <button class="btn btn-primary" (click)="handleApproval(3)">Accept</button>
  </div>
</div>
